import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Http } from '@angular/http';

@Injectable()
export class SalesPurchasesService extends ApiService {
  constructor(private http: Http) {
    super('api/sales-purchases/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/sales-purchases.service.ts